import Vue from 'vue';

// import { SESSION_LENGTH_MS } from "../constants";
import { getMatchabilityScore } from "../utilities/comparisonUtilities";

// function calculateScore() {
//   return 1;
// }

// function findIndex(array, dateTimeMS) {
//   let right = array.length;
//   let left = 0;
//   let idx;
//   // binary search
//   while (left < right) {
//     idx = Math.floor((right+left)/2);
//     if (array[idx].dateTimeMS < dateTimeMS) {
//       left = idx+1;
//     } else {
//       right = idx;
//     }
//   }
//   return left;
// }

const getDefaultState = () => {
  return {
    /** 
     * key: userID
     * value: {
     *  @metadata user metadata
     *  @preferences user preferences
     *  @matchabilityScore user matchability score
     * }
     * All arrays are sorted by dateTimeMS in ascending order
    */
    users: {}, 
  }
};

const state = getDefaultState();

const getters = {
  getUserMatchingData: (state) => (ID) => {
    if (state.users[ID]) {
      return {
        metadata: state.users[ID].metadata,
        preferences: state.users[ID].preferences
      }
    }
    return null;
  },
  getUserPreferences: (state) => (ID) => {
    if (state.users[ID]) {
      return state.users[ID].preferences;
    }
    return null;
  }
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  /**
   * @param {
   *  metadata {Object} the metadata of the user
   *  preferences {Array} public preferences of the user,
   *  matchabilityScore {Number} the matchability score of the user
   * } userData the user to add in the calendar
   */
  SET_USER(state, userData) {
    Vue.set(state.users, userData.metadata.ID, {
      metadata: userData.metadata,
      preferences: userData.preferences, // public preferences (might be null if only matched in the past)
      matchabilityScore: userData.matchabilityScore,
      // upcomingMatches: [], // unused atm
      // pastMatches: [],
      // matchable: [],
    })
  },

  /**
   * Updates the metadata of the user, or if the user does not exist, creates the user and sets its metadata
   * @param {Object} userMetadata the metadata of the user to add / update
   */
  SET_USER_METADATA(state, userMetadata) {
    if (Object.prototype.hasOwnProperty.call(state.users, userMetadata.ID)) {
      /* if the user exists, only set the metadata */
      state.users[userMetadata.ID].metadata = userMetadata;
    } else {
      Vue.set(state.users, userMetadata.ID, {
        metadata: userMetadata
      });
    }
  },

  /**
   * @param {String} userID user to delete from the calendar
   */
  REMOVE_USER(state, userID) {
    Vue.delete(state.users, userID);
  },

};

const actions = {
  resetUserData({commit}) {
    commit("RESET_STATE");
  },

  /**
   * Replaces the whole data.
   * @param {metadata: {Object}, preferences: {Array}} userData the data for the other user
   */
  setUser({commit, rootGetters}, userData) {
    if (userData && userData.metadata && userData.metadata.ID) {
      const currentUserPrefs = rootGetters["calendar/getCurrentUserPublicPreferences"];
      const matchabilityScore = getMatchabilityScore(currentUserPrefs, userData.preferences);
      userData.matchabilityScore = matchabilityScore;
      commit("SET_USER", userData);
      return matchabilityScore;
    }
    return 0;
  },
  /**
   * add the whole array of users
   * @param {Array} userArray array of users containing the keys metadata and preferences
   */
  setUserArray({commit, rootGetters}, userArray) {
    const currentUserPrefs = rootGetters["calendar/getCurrentUserPublicPreferences"];
    for (let i=0; i<userArray.length; i++) {
      if (userArray[i] && userArray[i].metadata && userArray[i].metadata.ID) {
        const matchabilityScore = getMatchabilityScore(currentUserPrefs, userArray[i].preferences);
        userArray[i].matchabilityScore = matchabilityScore;
        commit("SET_USER", userArray[i]);
      }
    }
  },

  /**
   * If the user does not exist, adds the user and adds only metadata
   * @param {Object} userMetadata the metadata of the user to add. 
   */
  setUserMetadata({commit}, userMetadata) {
    if (userMetadata.ID) {
      commit("SET_USER_METADATA", userMetadata);
    }
  },
  setUserMetadataArray({commit}, userMetadataArray) {
    for (let i=0; i<userMetadataArray.length; i++) {
      if (userMetadataArray[i] && userMetadataArray[i].ID) {
        commit("SET_USER_METADATA", userMetadataArray[i]);
      }
    }
  },
  
  removeUser({commit}, userID) {
    commit("REMOVE_USER", userID);
  }
  
};



const calendarUsers = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default calendarUsers;

